// extracted by mini-css-extract-plugin
module.exports = {"container-A":"privatepolicy_container-A__1a327","container":"privatepolicy_container__3iv8e","title":"privatepolicy_title__nuipH","content":"privatepolicy_content__32Z_2"};